/**  Redirect to /cart når Shopify AJAX /cart/add har svaret  **/
if (!window.__cartRedirectHooked) {
  window.__cartRedirectHooked = true;

  /* 1. patch fetch */
  const $fetch = window.fetch;
  window.fetch = function (url, opts) {
    return $fetch(url, opts).then(res => {
      if (url && url.includes('/cart/add')) {
        /* 200 = lagt i kurv -> send videre */
        res.ok && setTimeout(() => location.href = '/cart', 0);
      }
      return res;
    });
  };

  /* 2. patch gamle themes som bruger XMLHttpRequest */
  const $open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', () => {
      if (url && url.includes('/cart/add')) {
        this.status === 200 && (location.href = '/cart');
      }
    });
    return $open.apply(this, arguments);
  };
}
